import R from 'ramda';

const initialState = {
  // Undefined is absence of evidence, null is evidence of absence.
  allProperties: undefined,
  properties: undefined,
  myProperties: undefined,
  propertyDetails: undefined,
  creatingProperty: false,
  creatingPropertyDone: false,
  updatingProperty: false,
  updatingPropertyDone: false,
  deletingProperty: false,
  deletingPropertyDone: false,
  hasSearched: false,
};

export const createPropertyWithImagesDone = () => ({
  type: 'CREATE_PROPERTY_WITH_IMAGES_DONE',
});

const reducer = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    // Get properties

    case 'ON_PROPERTIES_PRESENCE': {
      const { properties } = action.payload;
      if (!properties) {
        return {
          ...state,
          allProperties: null,
          properties: null,
          creatingPropertyDone: false,
          updatingPropertyDone: false,
          deletingPropertyDone: false,
          hasSearched: false,
        };
      }

      const sortByCreatedAt = R.sortBy(R.prop('createdAt'));
      const sortedProperties = R.compose(
        R.reverse,
        R.sortBy(sortByCreatedAt),
        R.values,
      )(properties);

      return {
        ...state,
        allProperties: sortedProperties,
        properties: sortedProperties,
        creatingPropertyDone: false,
        updatingPropertyDone: false,
        deletingPropertyDone: false,
        hasSearched: false,
      };
    }

    // Get my properties

    case 'ON_MY_PROPERTIES_PRESENCE': {
      const { myProperties } = action.payload;
      if (!myProperties) {
        return {
          ...state,
          myProperties: null,
          creatingPropertyDone: false,
          updatingPropertyDone: false,
          deletingPropertyDone: false,
        };
      }

      const sortByCreatedAt = R.sortBy(R.prop('createdAt'));
      const sortedMyProperties = R.compose(
        R.reverse,
        R.sortBy(sortByCreatedAt),
        R.values,
      )(myProperties);

      return {
        ...state,
        myProperties: sortedMyProperties,
        creatingPropertyDone: false,
        updatingPropertyDone: false,
        deletingPropertyDone: false,
      };
    }

    // Get property

    case 'ON_PROPERTY_DETAILS_PRESENCE': {
      const { propertyDetails } = action.payload;
      if (!propertyDetails) {
        return {
          ...state,
          propertyDetails: null,
          creatingPropertyDone: false,
          updatingPropertyDone: false,
          deletingPropertyDone: false,
          properties: undefined,
        };
      }

      return {
        ...state,
        propertyDetails,
        creatingPropertyDone: false,
        updatingPropertyDone: false,
        deletingPropertyDone: false,
        properties: undefined,
      };
    }

    // Search properties

    case 'SEARCH_PROPERTIES': {
      const { searchVariables } = action.payload;
      return {
        ...state,
        hasSearched: true,
        properties: R.filter(property => (
          (R.contains(property.type, searchVariables.types) || R.isEmpty(searchVariables.types)) &&
          (property.price >= searchVariables.minPrice || searchVariables.minPrice === 0) &&
          (property.price <= searchVariables.maxPrice || searchVariables.maxPrice === 250000) &&
          (property.bedrooms === searchVariables.bedrooms || searchVariables.bedrooms === 0) &&
          (property.size >= searchVariables.minSize || searchVariables.minSize === 0) &&
          (property.size <= searchVariables.maxSize || searchVariables.maxSize === 500) &&
          (R.contains(property.zip, searchVariables.zips) || R.isEmpty(searchVariables.zips))
        ), state.allProperties),
      };
    }

    // Create property

    case 'CREATE_PROPERTY_WITH_IMAGES': {
      return { ...state, creatingProperty: true };
    }

    case 'CREATE_PROPERTY_IMAGES': {
      return { ...state };
    }

    case 'CREATE_PROPERTY': {
      return { ...state };
    }

    case 'CREATE_PROPERTY_WITH_IMAGES_DONE': {
      return { ...state, creatingProperty: false, creatingPropertyDone: true };
    }

    // Update property

    case 'UPDATE_PROPERTY_WITH_IMAGES': {
      return { ...state, updatingProperty: true };
    }

    case 'UPDATE_PROPERTY_IMAGES': {
      return { ...state };
    }

    case 'UPDATE_PROPERTY': {
      return { ...state };
    }

    case 'UPDATE_PROPERTY_WITH_IMAGES_DONE': {
      return { ...state, updatingProperty: false, updatingPropertyDone: true };
    }

    // Delete property

    case 'DELETE_PROPERTY_WITH_IMAGES': {
      return { ...state, deletingProperty: true };
    }

    case 'DELETE_PROPERTY_IMAGES': {
      return { ...state };
    }

    case 'DELETE_PROPERTY_WITH_IMAGES_DONE': {
      return { ...state, deletingProperty: false, deletingPropertyDone: true };
    }

    default:
      return state;

  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/common/properties/reducer.js